import React from 'react';

import { ParcelDetailContainerHistory, ParcelDetailNestedContainerHistory } from '@lanterds/types';
import DetailSection from 'src/components/common/DetailSection/DetailSection';
import DataTable from 'src/components/common/DataTable/DataTable';
import { formatDate } from 'src/util/formatters';
import { Indexable } from 'src/interfaces/interfaces';
import NestedTable from 'src/components/common/NestedTable/NestedTable';
import InfoTwoToneIcon from '@mui/icons-material/InfoTwoTone';

import './ContainerHistory.scss';
import { Tooltip } from '@mui/material';

interface ContainerHistoryProps {
    data: Partial<ParcelDetailContainerHistory>[];
}

export default function ContainerHistory({ data }: ContainerHistoryProps) {
    const labels = ['SU Number', 'Date Added', 'Date Removed'];
    const keys = ['shippingUnitNumber', 'dateAdded', 'dateRemoved'];

    const innerTables: Array<React.ReactElement> = [];

    function getInnerTableData(rawInnerData: Partial<ParcelDetailNestedContainerHistory>[]) {
        let tmpData: Array<Indexable> = [];

        if (rawInnerData && rawInnerData?.length > 0) {
            tmpData = rawInnerData.map((datum) => {
                return {
                    parcelCode: datum?.parcelCode,
                    dateAdded: formatDate(datum?.dateAdded),
                    dateRemoved: formatDate(datum?.dateRemoved),
                };
            });
        }

        return tmpData;
    }

    function getTableData(rawData: Partial<ParcelDetailContainerHistory>[]) {
        const innerTableConfig: Indexable = {
            labels: [
                'Parcel Code',
                <>
                    Date Added{' '}
                    <Tooltip arrow title="All times are local unless otherwise specified" className="info-tooltip">
                        <InfoTwoToneIcon color="primary" />
                    </Tooltip>
                </>,
                <>
                    Date Removed{' '}
                    <Tooltip arrow title="All times are local unless otherwise specified" className="info-tooltip">
                        <InfoTwoToneIcon color="primary" />
                    </Tooltip>
                </>,
            ],
            keys: ['parcelCode', 'dateAdded', 'dateRemoved'],
            data: [],
        };

        let tmpData: Array<Indexable> = [];

        if (rawData && rawData?.length > 0) {
            tmpData = rawData.map((datum, i) => {
                if (datum?.nestedContainer && datum?.nestedContainer?.length > 0) {
                    innerTableConfig.data = getInnerTableData(datum?.nestedContainer);
                    innerTables.splice(i, 0, <DataTable {...innerTableConfig} />);
                }

                return {
                    shippingUnitNumber: datum?.shippingUnitNumber,
                    type: datum?.type,
                    dateAdded: formatDate(datum?.dateAdded),
                    dateRemoved: formatDate(datum?.dateRemoved),
                };
            });
        }

        return tmpData;
    }

    const transformedData: Array<Indexable> = getTableData(data);

    const tableProps = { labels, keys, data: transformedData, innerTables };

    const content = transformedData && transformedData?.length ? <NestedTable {...tableProps} /> : <></>;

    return (
        <DetailSection id="container-history" title="Container History">
            <div className="container-history">{content}</div>
        </DetailSection>
    );
}

ContainerHistory.defaultProps = {
    data: [],
};
